export default __webpack_public_path__ + "static/media/bnr-ly1.4ccfb155.png";